import moment from "moment";

export const  HandleReformatDate = (date: moment.Moment | string) => {
    if (typeof date !== "string" && date.isValid()) {
        return moment(date).format("yyyy-MM-DD");;
    }
};